/**
 * Stage constructor
 * @constructor editor.actionbar.ActionBar
 * @param {object} dom DOM
 */

fx.ns("desktop.common.actionbar", class ActionBar extends fx.components.Box {
    
	constructor(data)
	{
		super(data);
		this.assets = fx.get("assets");
		this.on("updated", this.updateButtons, this.data.history);
	}


	onReady()
	{
		super.onReady();

		this.on("click", this.onUndo, this.undoButton);
		this.on("click", this.onRedo, this.redoButton);
		
		this.updateButtons();
	}

	create()
	{
		super.create();

		let box = new fx.components.Box();
		this.undoButton = new fx.components.IconButton({icon:this.assets.UndoIcon, label : fx.text("Annuler"), className : "undo"});
		this.redoButton = new fx.components.IconButton({icon:this.assets.RedoIcon, label : fx.text("Refaire"), className : "redo"});
		//this.undoButton.effect = "scale";
		//this.redoButton.effect = "scale";
		this.undoButton.visibleAtStart = false;
		this.redoButton.visibleAtStart = false;

		box.addChild(this.undoButton, {height:60, width:60, top :0, left : "center"} );
		box.addChild(this.redoButton, {height:60, width:60, top :80, left : "center"} );

		this.addChild(box, {top : "center", left : "center", width : 60});
	}

	updateButtons()
	{
		if (this.data && this.data.history && this.initialized)
		{
			this.undoButton.toggle(this.data.history.canUndo);
			this.redoButton.toggle(this.data.history.canRedo);
		}
	}


	onUndo()
	{
		this.data.history.undo()		
	}

	onRedo()
	{
		this.data.history.redo();
	}
	
	
});